import { apiClient } from "../../api/api"
import { Trello } from "../../types/trello"

const launchQuickbooksAuth = async (t: Trello.PowerUp.IFrame) => {
  const authUrl = await apiClient.getQuickbooksAuthUrl(t)
  window.open(authUrl, "_blank")
}

/**
 * Where QuickBooks Online lives for this build.
 *
 * Sandbox companies are served from their own front end, so a production link
 * cannot find a sandbox record — it lands on a "not found" in the wrong app.
 * Mirrors the API's own QUICKBOOKS_ENVIRONMENT; production is the default so a
 * missing variable can never point real users at the sandbox.
 */
const qboAppUrl =
  import.meta.env.VITE_QUICKBOOKS_ENV === "sandbox"
    ? "https://sandbox.qbo.intuit.com"
    : "https://qbo.intuit.com"

// Deep links into QBO. Both resolve against whichever company the user
// currently has open, so with several connected they can land on the right
// page in the wrong company.
const qboCustomerUrl = (qbCustomerId: string) =>
  `${qboAppUrl}/app/customerdetail?nameId=${encodeURIComponent(qbCustomerId)}`

const qboInvoiceUrl = (invoiceId: string) =>
  `${qboAppUrl}/app/invoice?txnId=${encodeURIComponent(invoiceId)}`

export { launchQuickbooksAuth, qboCustomerUrl, qboInvoiceUrl }
